import { Box, Step, StepButton, StepConnector, Stepper } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import WorkflowContext from "../context/WorkflowContext";
import styles from "../Workflow.module.scss";

const StepIcon: React.FC = () => {
  return <span className={styles.worflowStepIcon}></span>;
};

const Steps: React.FC = () => {
  const { t } = useTranslation();
  const { currentWorkflow, steps, activeStep } = useContext(WorkflowContext);
  const [currentStep, setCurrentStep] = useState(-1);
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (currentWorkflow) {
      if (
        currentWorkflow.ticketNumber &&
        location.pathname.indexOf(currentWorkflow.ticketNumber) > -1
      ) {
        const i = steps.findIndex((x) => location.pathname.endsWith(x.code));
        setCurrentStep(i);
      } else if (
        location.pathname.indexOf("new-publication") > -1 ||
        location.pathname.indexOf("modify-publication") > -1 ||
        location.pathname.indexOf("delete-publication") > -1
      ) {
        setCurrentStep(0);
      }
    }
  }, [location, currentWorkflow, steps]);

  const handleStep = (stepIndex: number) => {
    if (
      (steps[stepIndex].isCompleted || stepIndex === activeStep) &&
      currentWorkflow?.ticketNumber
    )
      navigate(`${currentWorkflow?.ticketNumber}/${steps[stepIndex].code}`, {
        relative: "route",
      });
  };

  const getConnectorClassName = (index: number) => {
    if (index === 0) return "";

    const previousStep = steps[index - 1];

    return previousStep.isCompleted &&
      previousStep.approvalRequired &&
      !previousStep.isApproved
      ? styles.pendingApproval
      : "";
  };

  return currentWorkflow ? (
    <Box className={styles.workflowSteps}>
      <Stepper
        nonLinear={true}
        alternativeLabel
        variant="elevation"
        connector={<></>}
      >
        {steps.map((s, index) => {
          return (
            <Step
              key={s.code}
              active={index === currentStep}
              completed={s.isCompleted}
              className={index === currentStep ? styles.currentStep : ""}
            >
              {index !== 0 && (
                <StepConnector className={getConnectorClassName(index)} />
              )}
              <StepButton
                color="inherit"
                onClick={() => handleStep(index)}
                icon={<StepIcon />}
              >
                {t(`stepCodes.${s.code}`)}
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  ) : (
    <></>
  );
};

export default Steps;
